import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useDeleteKeyFactsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	/** @param modifiedContactCount contacts the deletion actually touched - 0 means the scope matched nothing. */
	onSuccess?: (modifiedContactCount: number) => void;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ keyFactKind, tags }: { keyFactKind: Api.KeyDateKind; tags?: string[] }) => {
			return userSession.webServiceHelper.callAsync<number>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'Contact/KeyFact',
					queryParams: {
						keyFactKind,
						tags: tags?.length ? tags : undefined,
					},
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess,
	});
};
